import {
  BtnLanguage,
  LanguageBox,
  LanguageListBox,
  PolicyArticleTitle,
  PolicyContainer,
  PolicyList,
  PolicySectionTitle,
  PolicyText,
  PolicyTitle,
  StyledIconDropdown,
  StyledIconGlobal,
} from "styles/PolicyCommon";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const JaService = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onLanguageClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    document.documentElement.lang = "ja";
    document.title = "40weeks later";
    return () => {
      document.documentElement.lang = "ko";
      document.title = "열달후에";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">40weeks later</h1>
      <LanguageBox isOpen={isOpen}>
        <BtnLanguage onClick={onLanguageClick}>
          <StyledIconGlobal />
          EN
          <StyledIconDropdown />
        </BtnLanguage>
        <LanguageListBox>
          <ul>
            <li>
              <Link to="/policy/en/service">EN</Link>
            </li>
            <li className="selected">
              <em>JP</em>
            </li>
          </ul>
        </LanguageListBox>
      </LanguageBox>

      <PolicyTitle>「40weeks later」サービス利用約款</PolicyTitle>

      <PolicySectionTitle>
        ようこそ!「40weeks later」と共に大切な瞬間を満たしてみてください。
      </PolicySectionTitle>
      <PolicyText>
        当社の「40weeks
        later」サービス(以下「本サービス」といいます。)をご利用頂き誠にありがとうございます。本サービスはアプリを通じて妊娠期間の記録、他の会員との疎通、コンテンツ提供など皆様の生活に便利さを加えることができる多様なサービスを提供しています。本約款は、皆様がサービスを利用するために必要な権利、義務および責任事項、利用条件および手続きなど基本的な事項を規定しています。
      </PolicyText>
      <PolicyText>
        本サービスを提供する株式会社コネクトアイ(以下「当社」といいます。)が、日本のユーザーの皆様のために準備した以下の約款をよくお読みください。
      </PolicyText>

      <PolicyArticleTitle>1. 目的及び定義</PolicyArticleTitle>
      <PolicyText>
        本約款は、サービス利用者が当社が提供する本サービスに会員登録し、これを利用するにあたって、会社と会員(本約款に同意して会員登録を完了したサービス利用者。以下「会員」という。)の権利·義務及び責任事項を[規定することを目的とします。
      </PolicyText>
      <PolicyArticleTitle>2. 約款の効力及び変更</PolicyArticleTitle>
      <PolicyList>
        <li>
          ①
          本約款の内容はアプリサービスの画面に掲示したり、その他の方法で公示し、本約款に同意した会員全員にその効力が発生します。
        </li>
        <li>
          ②
          会社は必要に応じて、関連法令に違反しない範囲内で本約款を変更することができます。本約款が変更された場合、会社は変更事項を施行日の15日前から会員にサービスのお知らせまたはメールで通知することを原則とします。
        </li>
        <li>
          ③
          会社が前項の規定によりお知らせ又は通知時にお知らせ又は通知日から改正約款施行日の7日後までに拒否意思を表示しなければ承認したものとみなす旨を明確に告知したにもかかわらず、会員の意思表示がない場合には変更された約款を承認したものとみなします。
        </li>
        <li>
          ④
          会員は、変更された約款について拒否の意思を示すことにより、利用契約の解約を選択することができます。利用契約の解約はサービス内の会員退会を通じて可能です。
        </li>
        <li>
          ⑤
          本約款は、本約款に同意した日から本約款第12条による利用契約の解約時まで適用することを原則とします。ただし、本約款の一部条項は利用契約の解約後も有効に適用できます。
        </li>
      </PolicyList>
      <PolicyArticleTitle>3. 約款外準則</PolicyArticleTitle>
      <PolicyText>
        本約款に規定されていない事項については、関連法令又はサービスの運営政策及び規則(以下「運営政策」という。)の規定に従います。また、本約款と運営政策の内容が衝突した場合、運営政策に従います。
      </PolicyText>

      <PolicySectionTitle>会員の加入及び管理</PolicySectionTitle>
      <PolicyArticleTitle>4. 会員登録手続き</PolicyArticleTitle>
      <PolicyList>
        <li>
          ①
          サービス利用者が本約款を読んで「同意」ボタンを押したり「確認」などにチェックする方法を取った場合、本約款に同意したものとみなされます。
        </li>
        <li>
          ②
          当社のサービス利用のための会員登録は、サービス利用者が第1項のように同意した後、会社が定めた会員登録方法に従って会員ID(Eメールアカウント)を含む必須事項を入力し、"登録する"ないし"確認"ボタンを押す方法とします。ただし、当社が必要と認める場合は、会員に別途の書類を提出させることができます。
        </li>
      </PolicyList>
      <PolicyArticleTitle>5. 会員登録の成立及び留保及び拒絶</PolicyArticleTitle>
      <PolicyList>
        <li>
          ①
          会員登録は、第4条に定める手続によるサービス利用者の会員登録申請と当社の会員登録承諾によって成立します。当社は、会員登録申請者が必須事項等を誠実に入力して登録申請を完了した場合には、原則として登録を自動承諾します。ただし、当社は、以下の各号の場合には、その事由が解決されるまで承諾を留保し、又は承諾を取り消すことができます。
          <ul>
            <li>
              1)
              他人の名義やメールアドレスなど個人情報を利用してサービスに加入したものと判断される場合
            </li>
            <li>2) サービス提供設備容量に現実的な余裕がない場合</li>
            <li>
              3) サービス提供のための技術的な部分に問題があると判断される場合
            </li>
            <li>4) その他の会社が財政的、技術的に必要であると認める場合</li>
            <li>
              5)
              当社からサービス利用停止措置等を受けた者がサービス利用契約を任意に解約し再登録を申請する場合
            </li>
            <li>
              6)
              その他の関連法令に違反したり、細部指針など当社が定めた基準に反する場合
            </li>
          </ul>
        </li>
        <li>
          ②
          もし会員が上記の条件に違反してサービスに加入したことを確認した場合、当社は直ちに当該会員のサービス利用を停止させたり、アカウントを削除するなど適切な制限をすることができます。
        </li>
      </PolicyList>
      <PolicyArticleTitle>6. 会員ID等の管理責任</PolicyArticleTitle>
      <PolicyList>
        <li>
          ①
          会員は、サービス利用のための会員ID、ニックネーム、パスワードの管理に対する責任、本人IDの第三者による不正使用など、会員の故意·過失によって発生するすべての不利益に対する責任を負います。ただし、これが会社の故意·過失によって発生した場合は、会社が責任を負います。
        </li>
        <li>
          ②
          会員ID、パスワードおよびサービスロックパスワード、追加情報などが盗まれたり、第三者が使用していることを認知した場合には、直ちに本人のパスワードを修正するなどの措置を取らなければならず、直ちにこれを当社に通知して当社の案内を受けなければなりません。
        </li>
        <li>
          ③
          GOOGLE、APPLE、LINEなどSNS簡単ログインを利用する場合、該当SNSから発送される連動トークンを通じてログインされる方式なので、サービス内でパスワード探し、ID探しは不可能です。
        </li>
      </PolicyList>

      <PolicySectionTitle>サービスの利用</PolicySectionTitle>
      <PolicyArticleTitle>7. 多様なサービスの提供</PolicyArticleTitle>
      <PolicyList>
        <li>
          ①
          サービスのご利用は、会員登録後、当社のサービス使用承諾直後から可能です。会員は、サービスを構成するダイアリー、ガイドなどのサービスを会員が希望する時に自由に利用することができます。
        </li>
        <li>
          ②
          当社は、より良いサービスのためにサービスに必要なソフトウェアの更新バージョンを提供できます。ソフトウェアの更新には、重要な機能の追加または不要な機能の削除などが含まれています。より良いサービスをご利用いただけるよう、着実に更新してください。
        </li>
        <li>
          ③
          当社はより良いサービスを提供するために会員にサービス利用に関する各種告知、管理メッセージ、その他広告をはじめとする多様な情報をサービス内に表示したり会員のアカウント情報に登録されたメールなどの連絡先に直接発送することができます。ただし、当社は会員が受信同意をしていない営利目的の広告メール、プッシュなどを送信しません。
        </li>
        <li>
          ④
          サービス利用中にシステムエラーなどの問題点が見つかった場合は、いつでも当社のカスタマーセンターにお知らせください。
        </li>
        <li>
          ⑤
          サービスを利用する過程でWi-Fi無線インターネットを使用せず、加入された移動通信会社の通信網に連結して利用する場合、移動通信会社からデータ通信料金が賦課されることがある点に注意してください。サービス利用過程で発生するデータ通信料金は、会員の費用と責任の下、移動通信会社に納付しなければなりません。データ通信料金の詳細については、ご登録の移動通信会社にお問い合わせください。
        </li>
      </PolicyList>
      <PolicyArticleTitle>8. サービスの中断及び終了</PolicyArticleTitle>
      <PolicyList>
        <li>
          ①
          当社は、サービス及びセキュリティに係る設備を持続的かつ安定的に提供することに適合するように維持し、点検又は復旧等の措置を誠実に履行しなければなりません。
        </li>
        <li>
          ②
          サービス利用時間は、当社の業務的または技術的に不可能な場合を除き、年中無休1日24時間(00:00-24:00)を原則とします。ただし、以下の各号の場合、サービスの全部または一部を制限し、または中止または終了することができます。
          <ul>
            <li>
              1) サービス用設備のメンテナンス等のための定期又は臨時点検の場合
            </li>
            <li>
              2)
              停電、諸設備の障害又は利用量の暴走等により正常なサービス利用に支障がある場合
            </li>
            <li>
              3)
              関係会社との契約終了、政府の命令/規制など会社の諸事情によりサービスの全部又は一部を維持することができない場合
            </li>
            <li>4) その他天災地変、国家非常事態など不可抗力的理由がある場合</li>
          </ul>
        </li>
        <li>
          ③
          前項によるサービスの中断又は終了の場合には、あらかじめ第16条に定める方法により、会員に通知又は告知します。ただし、当社としても予測できない、または統制できない事由(会社の過失のないディスクまたはサーバー障害、外部データ連動に必要な外部システム障害、システムダウンなど)による場合は事前公示が不可能であり、これについてご了承ください。このような場合でも、当社が状況を把握し次第、できるだけ早いうちにサービスを復旧するよう努めてまいります。
        </li>
      </PolicyList>
      <PolicyArticleTitle>9. 掲示物の管理</PolicyArticleTitle>
      <PolicyList>
        <li>
          ①
          会員の掲示物が著作権法など関連法令に違反する内容を含む場合、権利者は当社に関連法令が定めた手続きに従って該当掲示物の掲示中断および削除などを要請することができ、当社は関連法令に従って措置をとります。
        </li>
        <li>
          ②
          当社は権利者の要請がない場合でも権利侵害が認められるほどの事由があったり、その他当社の政策及び関連法令に違反する場合には関連法令により当該掲示物に対して臨時措置、削除などをすることができます。
        </li>
        <li>
          ③
          上記に関する詳細な手続きは、情報通信網法および著作権法が規定した範囲内で会社が定めた申告手続きに従います。
        </li>
      </PolicyList>
      <PolicyArticleTitle>10. 権利の帰属及び著作物の利用</PolicyArticleTitle>
      <PolicyList>
        <li>
          ①
          会員は写真、文、情報、映像などの掲示物をサービス内に掲示することができ、これらの掲示物に対する著作権を含む知的財産権は当然掲示した会員が継続して保有します。
        </li>
        <li>
          ②
          会員が作成した掲示物は、検索結果またはカスタマイズされたコンテンツ領域、関連プロモーションなどにも公開されることがあります。この公開のために必要な範囲内では、一部の修正、複製、編集後に投稿されることもあります。この場合、当社は著作権法の規定を遵守し、会員はいつでもカスタマーセンターを通じて当該掲示物の削除などの措置を取ることができます。
        </li>
        <li>
          ③
          当社は会員の掲示物が関連法令に違反したりわいせつ掲示物、差別葛藤を助長する掲示物、広告·広報·スパム性掲示物、無分別な重複掲示物、アカウントを譲渡または取引する内容の掲示物、他人を詐称する掲示物などと判断される場合、別途の通知なしに削除したり掲示を拒否することができます。ただし、当社がすべてのコンテンツを検討する義務があるわけではないので、誰かが会員の権利を侵害した場合、申告または顧客センターを通じて助けを受けることができます。
        </li>
      </PolicyList>
      <PolicyArticleTitle>11. サービス利用の制限及び中止</PolicyArticleTitle>
      <PolicyList>
        <li>
          ①
          当社は、以下の各号の一つでも該当する事由が発生した場合には、会員のサービス利用を制限し、又は中止することができます。
          <ul>
            <li>
              1)
              他の会員のID及びパスワードを盗用して不当にサービスを利用する行為
            </li>
            <li>
              2)
              当社のサービスを利用して得た情報を当社の事前承諾なしに複製または流通させ、または商業的に利用する行為
            </li>
            <li>3) 他人の名誉を傷つけ、不利益を与える行為</li>
            <li>
              4)
              掲示板などにわいせつ物を掲載したりわいせつサイトを連結(リンク)する行為
            </li>
            <li>5) 当社または第三者の著作権などその他の権利を侵害する行為</li>
            <li>6) サービス内に当社や第三者等に対する虚偽事実を掲示する行為</li>
            <li>
              7)
              公共秩序及び美風良俗に違反する内容の情報、文章、図形、音声等を他人に流布する行為
            </li>
            <li>
              8)
              サービスに係る設備の誤動作や情報等の破壊及び混乱を引き起こすコンピュータウイルス感染資料を登録又は流布する行為
            </li>
            <li>
              9) サービスの運営を故意に妨害し、又は安定的な運営を妨害する行為
            </li>
            <li>10) 他人を装う行為及び他人との関係を虚偽で明示する行為</li>
            <li>11) 他の利用者の個人情報を収集、保存、公開する行為</li>
            <li>
              12)
              自己又は他人に財産上の利益を与え、又は他人に損害を与える目的で虚偽の情報を流通させる行為
            </li>
            <li>13) 財物を賭けて賭博をしたり、射幸行為をする行為</li>
            <li>
              14)
              羞恥心や嫌悪感又は恐怖心を引き起こす言葉若しくは音響、文若しくは画像又は映像を継続して相手に到達させ、相手の日常生活を妨げる行為
            </li>
            <li>
              15)
              大韓民国情報通信網法など関連法令により伝送または掲示が禁止される情報(コンピュータプログラムを含む)を伝送または掲示する行為
            </li>
            <li>
              16)
              当社又は関係会社の職員又はサービスの運営者を装って、又は詐称又は他人の名義を盗用して文を掲示する行為
            </li>
            <li>
              17)
              悪口、虚偽または悪意的な申告乱用など他の会員のサービス利用を妨害する行為
            </li>
            <li>
              18)
              その他現行法令、本約款及び当社が提供するサービスに関する詳細指針に違反する行為
            </li>
          </ul>
        </li>
        <li>
          ②
          当社は会員が第1項の行為をする場合、会員の違反行為などを調査することができ、該当掲示物などを削除または臨時削除したり、会員のサービス全体またはサービスを構成する一部個別サービスの利用をしばらくまたは継続して中断することができます。
        </li>
        <li>
          ③
          利用制限は違反活動の回数などの程度によって一時的制限から永久的制限に段階的制限することを原則としますが、関連法令で禁止する明白な不法行為や他人の権利侵害で緊急な危険または被害遮断が要求される事案に対しては一方的に本契約を直ちに解約することができ、サービス再加入または一部サービスの再利用が永久的に制限されることがあります。
        </li>
      </PolicyList>
      <PolicyArticleTitle>12. 利用契約の解約</PolicyArticleTitle>
      <PolicyList>
        <li>
          ① 会員が会員退会する場合、サービス利用契約も自動的に解約されます。
        </li>
        <li>
          ②
          サービス利用契約の解約を希望する場合、会員はいつでもサービス内に提供されるメニューを利用して脱退申請をすることができ、当社は法令の定めるところにより迅速に処理します。
        </li>
        <li>
          ③
          サービス利用契約が解約されると、関連法令および個人情報処理方針に従って会員の一定情報を保有する場合を除き、会員がダイアリーに保存した記録などすべてのデータは削除されます。ただし、コミュニティなど他の会員と情報を共有するサービスは、会員が作成した掲示物が他の会員によって他の共有機能として掲示されたり、会員が他の会員の掲示物にコメントなどを追加するなど多様な場合があるので、脱退時に自動削除されずにそのまま残っています。
        </li>
        <li>
          ④
          前項の規定により、会員が削除していない掲示物は、他の会員の正常なサービス利用のために必要な範囲内で削除されずに残っていることになります。したがって、該当掲示物およびコメントは削除されませんので、必ず脱退申請前に削除してください。
          ただし、掲示物は残っていてもニックネームなど脱退会員の情報はすべて削除され露出されません。
        </li>
        <li>
          ⑤
          SNS簡単ログインでサービス利用途中にサービスと連動した各SNSアカウントを脱退する場合、直ちにSNS連動トークンが削除されるのでサービス利用が不可能であり、サービス利用契約も自動的に解約されます。したがって、SNSの簡単ログインアカウントで利用されていたデータは、第12条3項に基づいて処理され、削除されたデータはこれ以上復旧できません。
        </li>
        <li>
          ⑥
          サービス利用契約が解約された場合でも、再び会員登録を通じてサービス利用契約の締結を申請することができます。ただし、会員が関連法令、本約款および詳細指針を遵守せず、サービスの利用が中断された状態で利用契約を解約した後、再び利用契約締結を申請する場合には、サービス加入に一定期間の時間的制限があったり拒否されたりすることがあります。
        </li>
      </PolicyList>
      <PolicyArticleTitle>13. 個人情報の保護</PolicyArticleTitle>
      <PolicyList>
        <li>
          ①
          当社はサービスを提供するために関連法令の規定に従って会員から必要な個人情報を収集します。会員の個人情報は、サービスの円滑な提供のために、会員が同意した目的と範囲内でのみ利用されます。個人情報収集に関する詳細については、「プライバシーポリシー」により詳しくご案内します。
        </li>
        <li>
          ②
          個人情報の安全な処理は、当社にとって最も重要なことの1つです。当社は、サービス提供に関して知り得た会員の個人情報を本人の承諾なしに第三者に漏洩·配布することなく、これを保護するために努力します。関連法令に基づき、または会員が別途同意しない限り、当社が会員の個人情報を第三者に提供することは決してありませんので、ご安心ください。
        </li>
        <li>
          ③
          当社が第三者とのサービス提供契約等を締結して会員にサービスを提供する場合、当社はサービス提供のために第三者に提供される具体的な会員情報を明示し、会員の個別的かつ明示的な同意を得た後、同意の範囲内で当該サービスの提供期間中に限り会員の個人情報を第三者と共有するなど関連法令を遵守します。
        </li>
        <li>
          ④
          当社が会員の個人情報を安全に処理するために傾ける努力やその他の詳細は、当社が別途定めた「プライバシーポリシー」に従います。
        </li>
      </PolicyList>

      <PolicySectionTitle>その他</PolicySectionTitle>
      <PolicyArticleTitle>14. 損害賠償</PolicyArticleTitle>
      <PolicyList>
        <li>
          ①
          当社は関連法令上許容される限度内でサービスに関して本約款に明示されていないいかなる具体的な事項に対する約定や保証をしません。また、当社はCP(コンテンツプロバイダー)が提供または公共データなど外部から提供するデータを連動したり、会員が作成するなどの方法でサービスに掲載された情報、資料、事実の信頼度、正確性などについては保証を行い、当社の過失なく発生した会員の損害については責任を負いません。
        </li>
        <li>
          ②
          当社は、当社の過失なく発生した下記の損害については責任を負いません。また、当社は法律上許容される限度内で間接損害、特別損害、結果的損害、懲戒的損害および懲罰的損害に対する責任を負担しません。
          <ul>
            <li>1) 天災地変又はこれに準ずる不可抗力の状態で生じた損害</li>
            <li>2) 会員の帰責事由によりサービス利用にエラーが発生した場合</li>
            <li>3) サービスへのアクセスまたは利用過程で発生する個人的な損害</li>
            <li>
              4)
              第三者が違法に当社のサーバーに接続したり、サーバーを利用することによって生じる損害
            </li>
            <li>
              5)
              第三者が当社サーバへの転送又は当社サーバからの転送を妨害することにより生じる損害
            </li>
            <li>
              6)
              第三者が悪性プログラムを伝送または流布することによって発生する損害
            </li>
            <li>
              7)
              送信されたデータの省略、欠落、破壊などで発生した損害、名誉毀損など第三者がサービスを利用する過程で発生した損害
            </li>
            <li>8) その他当社の故意又は過失のない事由により生じた損害</li>
          </ul>
        </li>
        <li>
          ③
          当社は、会員がサービスを利用して期待する収益等を喪失したことについて責任を負わず、その他サービスを通じて得た資料による損害等についても責任を負いません。
        </li>
        <li>
          ④
          当社は当社の過失がない場合、会員相互間または会員と第三者相互間でサービスを媒介に発生した紛争に対しては介入する義務がなく、これによる損害を賠償する責任もありません。
        </li>
      </PolicyList>
      <PolicyArticleTitle>15. 通知及びお知らせ</PolicyArticleTitle>
      <PolicyText>
        当社は会員との意見交換を大切にしています。会員はいつでも当社カスタマーセンターに意見を登録することができます。サービス利用者全体に対するお知らせは、1週間(7日)以上サービス通知に掲示しなければ効力が発生しません。会員に重大な影響を及ぼす事項の場合、アカウントに登録されたメールアドレスにメール送信、アプリプッシュ通知メッセージ送信など別途の電子的手段などの方法で個別にお知らせします。
      </PolicyText>
      <PolicyArticleTitle>16. 紛争の解決</PolicyArticleTitle>
      <PolicyText>
        本約款またはサービスは、大韓民国法令により規定され、履行されます。サービス利用に関して当社と会員の間で紛争が発生した場合、解決のために誠実に協議します。それにもかかわらず解決されなければ、ソウル中央地方裁判所を第一審の専属的合意管轄裁判所とすることとします。
      </PolicyText>
      <br />
      <PolicyText>制定日2023年10月20日</PolicyText>
    </PolicyContainer>
  );
};

export default JaService;
